export default ".n-button.n-button--primary-type.n-button--ghost:hover .n-button__border {\n  border-color: #0E67DA80;\n}"